/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2IconButtonStop/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2IconButtonStop({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2IconButtonStop",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 14,
  height = 14,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#000"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2IconButtonStop.Svg"
  data-view-path={viewPath}
 viewBox="0 0 14 14"
 style={{'--as-1-17WqiR': alignSelf,'--mt-2-17WqiR': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-17WqiR': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-17WqiR': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-17WqiR': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-17WqiR': opacity,'--w-10-17WqiR': typeof width === 'number' ? `${width}px` : width,'--h-11-17WqiR': typeof height === 'number' ? `${height}px` : height,'--f-12-17WqiR': fill,'--a-7-17WqiR': isAnimated ? animation : "none",'--sd-8-17WqiR': isAnimated ? strokeDashoffset : 0,'--sd-9-17WqiR': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<g
  data-testid="Tysiav2IconButtonStop.SvgGroup"
  data-view-path={viewPath}
 clipPath="url(#clip0_382_99316)"
 className="views-block"
>
<path
  data-testid="Tysiav2IconButtonStop.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M1.5 0A1.5 1.5 0 000 1.5v11A1.5 1.5 0 001.5 14h11a1.5 1.5 0 001.5-1.5v-11A1.5 1.5 0 0012.5 0h-11z"
 style={{'--f-12-17WqiR': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</g>
</svg>
{children}
</React.Fragment>)
}